import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPlayStyle0 = gravityIconIndividualCss;

const GravityIconPlay = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'f18cc293be95e0d8cab19f8ba532bcc104bd5d88', color: this.color, size: this.size }, h("svg", { key: '26959f05b7519c4e827d622eb9df3391b9baff1c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '86581468615842c4db772bc1c4a5677db39e2429', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m7.22 17.44 10.38-5.905a.608.608 0 0 0 .283-.531.607.607 0 0 0-.282-.531L7.22 4.568a.426.426 0 0 0-.495.023.615.615 0 0 0-.225.52v11.81a.618.618 0 0 0 .239.492.434.434 0 0 0 .48.027Z", fill: "currentColor" }))));
    }
};
GravityIconPlay.style = GravityIconPlayStyle0;

export { GravityIconPlay as gravity_icon_play };

//# sourceMappingURL=gravity-icon-play.entry.js.map